import { IAppRoute } from 'interfaces/route';
import * as React from 'react';

import AdminModule from './Admin';
import NewPasswordPage from './Public/NewPassword';
import LoginDialog from 'components/Dialogs/Login';
import ChangePasswordDialog from 'components/Dialogs/ChangePassword';

export default class Pages extends React.PureComponent {
  public static routes: IAppRoute[] = [
    {
      path: '/nova-senha',
      exact: true,
      allowAnonymous: true,
      component: NewPasswordPage
    },
    {
      path: '/login',
      exact: true,
      allowAnonymous: true,
      component: LoginDialog
    },
    {
      path: '/change-password',
      exact: true,
      allowAnonymous: true,
      component: ChangePasswordDialog
    },
    {
      path: '/',
      component: AdminModule
    },
  ];

  render() {
    return this.props.children;
  }
}
